/**
 * Catálogo de cópia em português brasileiro para o recurso de comércio
 * (`@gamecodex/world-ui` → `features/commerce`).
 *
 * As chaves refletem as chamadas `t('commerce.*')` nos componentes React do recurso.
 * Os valores são as strings de português brasileiro traduzidas.
 */
export const commercePtBR = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoTitle': 'Resgate sua Biblioteca',
  'commerce.dtrpg.seoDescription': 'Importe sua biblioteca da DriveThruRPG e resgate seus PDFs do Grymwyrd.',
  'commerce.dtrpg.heading': 'Resgate sua Biblioteca',
  'commerce.dtrpg.intro':
    'Comprou Grymwyrd na DriveThruRPG ou apoiou a campanha? Entre com seu email de compra para importar sua biblioteca e resgatar suas cópias.',
  'commerce.dtrpg.sendLinkError': 'Não conseguimos enviar seu link de entrada agora. Tente novamente em breve.',
  'commerce.dtrpg.checkInboxPrefix': 'Verifique sua caixa de entrada em',
  'commerce.dtrpg.checkInboxSuffix':
    'Se esse email comprou ou apoiou Grymwyrd, um link de entrada está a caminho — clique nele para voltar aqui e resgatar sua biblioteca.',
  'commerce.dtrpg.linkAutoSignIn': 'O link te conecta automaticamente — nenhuma senha necessária.',
  'commerce.dtrpg.purchaseEmailLabel': 'Seu email de compra / apoio',
  'commerce.dtrpg.sendingLink': 'Enviando link…',
  'commerce.dtrpg.emailLinkCta': 'Me envie um link de entrada por email',
  'commerce.dtrpg.signedInAs': 'Conectado como',
  'commerce.dtrpg.signOut': 'Sair',
  'commerce.dtrpg.dtrpgEmailLabel': 'Email do DriveThruRPG',
  'commerce.dtrpg.dtrpgEmailOptional': '(opcional — se diferente do acima)',
  'commerce.dtrpg.dtrpgEmailHelp': 'Usamos isso para encontrar suas compras no DriveThruRPG ao conceder sua biblioteca.',
  'commerce.dtrpg.libraryHeading': 'Sua biblioteca Grymwyrd',
  'commerce.dtrpg.noTitles': 'Nenhum título importável configurado ainda.',
  'commerce.dtrpg.claimNotInLibrary':
    'Este título ainda não está em sua biblioteca. Certifique-se de usar o email de compra correto.',
  'commerce.dtrpg.claimSessionExpired': 'Sua sessão expirou — entre novamente.',
  'commerce.dtrpg.claimError': 'Não conseguimos resgatar este título agora. Tente novamente.',
  'commerce.dtrpg.preparingCopy': 'Preparando sua cópia…',
  'commerce.dtrpg.download': 'Baixar',
  'commerce.dtrpg.preparing': 'Preparando…',
  'commerce.dtrpg.claiming': 'Resgatando…',
  'commerce.dtrpg.claim': 'Resgatar',

  // PaywallPrompt.tsx
  'commerce.paywall.checkoutFailed': 'Não foi possível abrir o checkout. Tente novamente em breve.',
  'commerce.paywall.signInToPurchase': 'Entre para completar esta compra.',
  'commerce.paywall.vaultSealed': 'O cofre do comerciante está selado por enquanto — tente novamente em breve.',
  'commerce.paywall.signInToUnlock': 'Entre para desbloquear',
  'commerce.paywall.comingSoonTitle': 'Esta compra em breve estará disponível',
  'commerce.paywall.priceComingSoon': '{price} — em breve',
  'commerce.paywall.comingSoon': 'Em breve',
  'commerce.paywall.openingVault': 'Abrindo o cofre…',
  'commerce.paywall.unlockPrice': 'Desbloquear — {price}',
  'commerce.paywall.unlock': 'Desbloquear',

  // MarketplacePage.tsx
  'commerce.marketplace.installSuccess': 'Instalou "{name}" em sua mesa.',
  'commerce.marketplace.installNotOwned': 'Você ainda não possui este pacote — a compra de pacotes em breve estará disponível.',
  'commerce.marketplace.installHostOnly': 'Apenas o anfitrião da mesa pode instalar um pacote.',
  'commerce.marketplace.installError': 'Não foi possível instalar este pacote. Tente novamente.',
  'commerce.marketplace.installed': 'Instalado',
  'commerce.marketplace.installing': 'Instalando…',
  'commerce.marketplace.installOnTable': 'Instalar na mesa',
  'commerce.marketplace.seoTitle': 'Mercado — Pacotes',
  'commerce.marketplace.seoDescription':
    'Procure e instale pacotes de conteúdo de criadores — mapas, cenas, materiais de jogo e predefinições — em suas mesas.',
  'commerce.marketplace.eyebrow': 'Mercado',
  'commerce.marketplace.heading': 'Pacotes de Conteúdo',
  'commerce.marketplace.intro':
    'Mapas, cenas, materiais de jogo e predefinições rápidas — instale-os em suas mesas com um clique.',
  'commerce.marketplace.installingOnto': 'Instalando na mesa {tableId}.',
  'commerce.marketplace.signInHeading': 'Entre para ver seus pacotes',
  'commerce.marketplace.signInBlurb': 'O catálogo de pacotes está vinculado à sua conta de criador.',
  'commerce.marketplace.signIn': 'Entrar',
  'commerce.marketplace.loading': 'Convocando seus pacotes…',
  'commerce.marketplace.noPacksHeading': 'Nenhum pacote ainda',
  'commerce.marketplace.noPacksBlurb':
    'Você ainda não publicou nenhum pacote. Um mercado público para procurar pacotes de outros criadores em breve estará disponível.',
  'commerce.marketplace.footer': 'Procurar pacotes de outros criadores e pacotes pagos estão a caminho.',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.perk1Title': 'Mesas exclusivas para assinantes',
  'commerce.subscriber.perk1Blurb': 'Sente-se em mesas que seus anfitriões favoritos reservam para assinantes.',
  'commerce.subscriber.perk2Title': 'Conteúdo antecipado e exclusivo',
  'commerce.subscriber.perk2Blurb': 'Obtenha capítulos de campanha, cenas e materiais de jogo antes de qualquer um.',
  'commerce.subscriber.perk3Title': 'Distintivo de assinante',
  'commerce.subscriber.perk3Blurb': 'Uma marca de prestígio em seu perfil e na mesa.',
  'commerce.subscriber.seoTitle': 'Benefícios para Assinantes',
  'commerce.subscriber.seoDescription':
    'Torne-se um assinante para mesas exclusivas, conteúdo antecipado e distintivo de assinante.',
  'commerce.subscriber.heading': 'Torne-se um Assinante',
  'commerce.subscriber.intro':
    'Apoie os anfitriões e criadores que ama — e desbloqueie os benefícios que eles reservam para seu círculo interno.',
  'commerce.subscriber.activeHeading': 'Você é um assinante',
  'commerce.subscriber.activeBlurb':
    'Seus benefícios estão ativos. Procure o brasão de assinante em mesas que você pode se juntar.',
  'commerce.subscriber.findTable': 'Encontre uma mesa para assinantes',
  'commerce.subscriber.paywallTitle': 'Assinante Grymwyrd',
  'commerce.subscriber.paywallBlurb':
    'Desbloqueie mesas exclusivas para assinantes, conteúdo antecipado e seu distintivo de assinante.',
  'commerce.subscriber.paywallPrice': 'a partir de R$25/mês',

  // TicketCheckoutPage.tsx
  'commerce.ticket.checkoutFailed': 'Não foi possível abrir o checkout. Tente novamente em breve.',
  'commerce.ticket.signInToBuy': 'Entre para comprar um lugar nesta mesa.',
  'commerce.ticket.boxOfficeClosed': 'A bilheteria está fechada por enquanto — tente novamente em breve.',
  'commerce.ticket.seoTitle': 'Compre um Lugar',
  'commerce.ticket.seoDescription': 'Reserve seu lugar em uma mesa com ingressos.',
  'commerce.ticket.eyebrow': 'Mesa com Ingressos',
  'commerce.ticket.heading': 'Reserve seu Lugar',
  'commerce.ticket.loading': 'Carregando a mesa…',
  'commerce.ticket.notFoundHeading': 'Mesa não encontrada',
  'commerce.ticket.notFoundBlurb': 'Esta mesa pode ter fechado, ou nunca foi aberta.',
  'commerce.ticket.backToLobby': 'Voltar ao saguão',
  'commerce.ticket.freeHeading': 'Esta mesa é grátis para participar',
  'commerce.ticket.freeBlurb': 'Nenhum ingresso necessário — puxe uma cadeira.',
  'commerce.ticket.goToLobby': 'Ir para o saguão',
  'commerce.ticket.untitledTable': 'Mesa sem título',
  'commerce.ticket.seatPrice': 'Preço do lugar',
  'commerce.ticket.spectatorsNote': 'Os espectadores também devem ter um ingresso para esta mesa.',
  'commerce.ticket.paymentReceived': 'Pagamento recebido — seu lugar está reservado. Vá para o saguão para ocupá-lo.',
  'commerce.ticket.signInToBuySeat': 'Entre para comprar um lugar',
  'commerce.ticket.openingBoxOffice': 'Abrindo a bilheteria…',
  'commerce.ticket.buySeatPrice': 'Comprar lugar — {price}',
  'commerce.ticket.comingSoonTitle': 'Venda de ingressos em breve',
  'commerce.ticket.ticketingComingSoon': 'Venda de ingressos em breve',
  'commerce.ticket.comingSoonFooter': 'Lugares pagos estão quase prontos. Por enquanto, peça ao anfitrião um convite gratuito.',

  // TipGoalManagerPage.tsx
  'commerce.tip.errHostOnlyGoal': 'Apenas o anfitrião da mesa pode gerenciar objetivos.',
  'commerce.tip.errHostOnlyBounty': 'Apenas o anfitrião da mesa pode gerenciar recompensas.',
  'commerce.tip.errMaxGoal': 'Você atingiu o número máximo de objetivos para esta mesa.',
  'commerce.tip.errMaxBounty': 'Você atingiu o número máximo de recompensas para esta mesa.',
  'commerce.tip.errMissingGoal': 'Esse objetivo está faltando detalhes necessários.',
  'commerce.tip.errMissingBounty': 'Essa recompensa está faltando detalhes necessários.',
  'commerce.tip.errSignIn': 'Entre como anfitrião para gerenciar esta mesa.',
  'commerce.tip.errSaveFailedGoal': 'Não foi possível salvar o objetivo. Tente novamente.',
  'commerce.tip.errSaveFailedBounty': 'Não foi possível salvar a recompensa. Tente novamente.',
  'commerce.tip.goalValidation': 'Adicione um rótulo e uma meta em dólares positiva.',
  'commerce.tip.goalAdded': 'Objetivo "{label}" adicionado.',
  'commerce.tip.goalLabelPlaceholder': 'Rótulo do objetivo (ex.: invocar o chefe)',
  'commerce.tip.targetPlaceholder': 'Meta $',
  'commerce.tip.cuePlaceholder': 'Sinal quando atingido (ex.: fanfarra)',
  'commerce.tip.addGoal': 'Adicionar objetivo',
  'commerce.tip.bountyValidation': 'Adicione um rótulo, uma meta positiva e um disparador.',
  'commerce.tip.bountyAdded': 'Recompensa "{label}" adicionada.',
  'commerce.tip.bountyLabelPlaceholder': 'Rótulo da recompensa (ex.: um 20 natural salva o grupo)',
  'commerce.tip.triggerPlaceholder': 'Disparador (ex.: um 20 natural)',
  'commerce.tip.addBounty': 'Adicionar recompensa',
  'commerce.tip.signInToManage': 'Entre para gerenciar esta mesa.',
  'commerce.tip.bountyClaimed': 'Recompensa "{label}" reivindicada.',
  'commerce.tip.seoTitle': 'Objetivos e Recompensas de Gorjeta',
  'commerce.tip.seoDescription': 'Defina objetivos e recompensas de gorjeta para sua mesa.',
  'commerce.tip.backToLobby': 'Voltar ao saguão',
  'commerce.tip.heading': 'Objetivos e Recompensas de Gorjeta',
  'commerce.tip.intro':
    'Defina objetivos e recompensas para sua mesa. Quando o cálice transborda, o sinal dispara para sua audiência. O display de exibição ao vivo é tratado pela sua sobreposição de transmissão.',
  'commerce.tip.loading': 'Lendo o livro de contas…',
  'commerce.tip.loadErrorTitle': 'Não foi possível carregar o livro de contas',
  'commerce.tip.raisedSoFar': 'Arrecadado até agora:',
  'commerce.tip.tipGoalsHeading': 'Objetivos de Gorjeta',
  'commerce.tip.noGoals': 'Nenhum objetivo ainda — adicione o primeiro abaixo.',
  'commerce.tip.reachedAria': 'atingido',
  'commerce.tip.bountiesHeading': 'Recompensas',
  'commerce.tip.noBounties': 'Nenhuma recompensa ainda — adicione a primeira abaixo.',
  'commerce.tip.whenLabel': '· quando: {trigger}',
  'commerce.tip.claimed': 'Reivindicado',
  'commerce.tip.claimTitleReady': 'Marcar esta recompensa como reivindicada',
  'commerce.tip.claimTitleNotFunded': 'Ainda não financiado',
  'commerce.tip.claim': 'Reivindicar',
} as const
